/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.UnscheduledModelFilter = (function() {

    /**
     * Namespace UnscheduledModelFilter.
     * @exports UnscheduledModelFilter
     * @namespace
     */
    var UnscheduledModelFilter = {};

    UnscheduledModelFilter.UnscheduledModelFilterModel = (function() {

        /**
         * Properties of an UnscheduledModelFilterModel.
         * @memberof UnscheduledModelFilter
         * @interface IUnscheduledModelFilterModel
         * @property {string|null} [make] UnscheduledModelFilterModel make
         * @property {string|null} [model] UnscheduledModelFilterModel model
         * @property {number|null} [active] UnscheduledModelFilterModel active
         * @property {string|null} [sortColumn] UnscheduledModelFilterModel sortColumn
         * @property {string|null} [sortOrder] UnscheduledModelFilterModel sortOrder
         * @property {number|null} [pageIndex] UnscheduledModelFilterModel pageIndex
         * @property {number|null} [pageSize] UnscheduledModelFilterModel pageSize
         */

        /**
         * Constructs a new UnscheduledModelFilterModel.
         * @memberof UnscheduledModelFilter
         * @classdesc Represents an UnscheduledModelFilterModel.
         * @implements IUnscheduledModelFilterModel
         * @constructor
         * @param {UnscheduledModelFilter.IUnscheduledModelFilterModel=} [p] Properties to set
         */
        function UnscheduledModelFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UnscheduledModelFilterModel make.
         * @member {string|null|undefined} make
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        UnscheduledModelFilterModel.prototype.make = null;

        /**
         * UnscheduledModelFilterModel model.
         * @member {string|null|undefined} model
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        UnscheduledModelFilterModel.prototype.model = null;

        /**
         * UnscheduledModelFilterModel active.
         * @member {number|null|undefined} active
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        UnscheduledModelFilterModel.prototype.active = null;

        /**
         * UnscheduledModelFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        UnscheduledModelFilterModel.prototype.sortColumn = null;

        /**
         * UnscheduledModelFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        UnscheduledModelFilterModel.prototype.sortOrder = null;

        /**
         * UnscheduledModelFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        UnscheduledModelFilterModel.prototype.pageIndex = null;

        /**
         * UnscheduledModelFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        UnscheduledModelFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * UnscheduledModelFilterModel _make.
         * @member {"make"|undefined} _make
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelFilterModel.prototype, "_make", {
            get: $util.oneOfGetter($oneOfFields = ["make"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * UnscheduledModelFilterModel _model.
         * @member {"model"|undefined} _model
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelFilterModel.prototype, "_model", {
            get: $util.oneOfGetter($oneOfFields = ["model"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * UnscheduledModelFilterModel _active.
         * @member {"active"|undefined} _active
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelFilterModel.prototype, "_active", {
            get: $util.oneOfGetter($oneOfFields = ["active"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * UnscheduledModelFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * UnscheduledModelFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * UnscheduledModelFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * UnscheduledModelFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @instance
         */
        Object.defineProperty(UnscheduledModelFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified UnscheduledModelFilterModel message. Does not implicitly {@link UnscheduledModelFilter.UnscheduledModelFilterModel.verify|verify} messages.
         * @function encode
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @static
         * @param {UnscheduledModelFilter.IUnscheduledModelFilterModel} m UnscheduledModelFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnscheduledModelFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.make != null && Object.hasOwnProperty.call(m, "make"))
                w.uint32(10).string(m.make);
            if (m.model != null && Object.hasOwnProperty.call(m, "model"))
                w.uint32(18).string(m.model);
            if (m.active != null && Object.hasOwnProperty.call(m, "active"))
                w.uint32(24).int32(m.active);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(34).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(42).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(48).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(56).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified UnscheduledModelFilterModel message, length delimited. Does not implicitly {@link UnscheduledModelFilter.UnscheduledModelFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @static
         * @param {UnscheduledModelFilter.IUnscheduledModelFilterModel} message UnscheduledModelFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnscheduledModelFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UnscheduledModelFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {UnscheduledModelFilter.UnscheduledModelFilterModel} UnscheduledModelFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnscheduledModelFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.UnscheduledModelFilter.UnscheduledModelFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.make = r.string();
                    break;
                case 2:
                    m.model = r.string();
                    break;
                case 3:
                    m.active = r.int32();
                    break;
                case 4:
                    m.sortColumn = r.string();
                    break;
                case 5:
                    m.sortOrder = r.string();
                    break;
                case 6:
                    m.pageIndex = r.int32();
                    break;
                case 7:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes an UnscheduledModelFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof UnscheduledModelFilter.UnscheduledModelFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {UnscheduledModelFilter.UnscheduledModelFilterModel} UnscheduledModelFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnscheduledModelFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return UnscheduledModelFilterModel;
    })();

    return UnscheduledModelFilter;
})();

module.exports = $root;
